import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { AddBtn } from "@commonComponents/AddBtn";
import { FormTitle } from "@commonComponents/FormTitle";

const  GoodLocationDetail=({saveData,updateData,renderForm,dataSource,className,translate})=>{
    const dispatch=useDispatch()
    const [toggleAddBtn,setToggleAddBtn]=useState(true)
    
    const onChange=useCallback(({target: {value,name}})=>dispatch(updateData({key:"locationOfGoods",data:{[name]:value}})),[updateData])
      

    const onBlur=useCallback(({target: {value,name}})=>saveData({"locationOfGoods":{[name]:value || " ",id:dataSource.id}}),[saveData,dataSource.id])

    const onSelect=useCallback((e, {value,name})=>{
      onChange({target:{value: value?.trim(),name}})
      onBlur({target:{value: value?.trim(),name}})
            ,[onChange,onBlur]
    },[onChange,onBlur])
    
    const getLocationId=async()=>{
      setToggleAddBtn(prev=>!prev)
      const response=await onBlur({target:{value:" ",name:"postcode"}})
      setToggleAddBtn(prev=>!prev)
      const id=response?.locationOfGoods?.id
      if(id)
      onChange({target:{value:id,name:"id"}})
      
     }

    
  
  return(
    <div className={`${className} col formContainer`}>
        <FormTitle className="formTitle" textAlign="start" title="GOODS_LOCATION" boxNumber="5/23" />
    { dataSource.id ? renderForm && renderForm({onSelect,onChange,onBlur,dataSource,translate}) : <AddBtn disabled={!toggleAddBtn}  style={{width:"max-content"}} onClick={getLocationId} text={translate("ADD")} />}
    </div>
  )
}


export default GoodLocationDetail